import PropTypes from 'prop-types'
import { useState, useEffect, useCallback } from 'react'
import { Modal } from 'react-bootstrap'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { useAuth } from '../../hooks/useAuth'
import ImagenPerfil from '../imagen/ImagenPerfil'
import Upload from '../perfil/Upload'
import * as domiciliosService from '../servicios/domiciliosService'
import * as reputacionService from '../servicios/reputacionService'
import * as usuarioService from '../servicios/usuarioService'
import styles from './Perfil.module.css'

const ESTRELLAS_REPUTACION = 5

const Hero = (props) => {
  const [datos, setDatos] = useState([])
  const [reputacion, setReputacion] = useState([])
  const [domicilios, setDomicilios] = useState([])
  const [show, setShow] = useState(false)
  const idTipo = 3

  const { loginDataContext: { idUsuario, tipoUsuario } = {}, cargandoUsuario } = useAuth()

  const fetchData = async () => {
    if (cargandoUsuario || !idUsuario || !tipoUsuario) return
    try {
      const { data: reputacion } = await reputacionService.buscarReputacion(idUsuario)
      setReputacion(reputacion)
      const { data: domicilios } = await domiciliosService.buscarTodas(idUsuario, tipoUsuario)
      setDomicilios(domicilios)
      const { data: datos } = await usuarioService.buscarPorId(idUsuario)
      setDatos(datos)
    } catch (error) {
      toastErrorLog(error, 'Ocurrió un error al obtener los datos del perfil.', 'perfil')
    }
  }

  useEffect(() => {
    fetchData()
  }, [tipoUsuario, idUsuario, cargandoUsuario])

  const obtenerReputacionPromedio = useCallback(
    (reputacionData) => {
      let reputacionPromedio
      if (reputacionData === 0) {
        reputacionPromedio = 0
      } else {
        const arrayReputacionPromedio = reputacion.map((e) => e.promedioReputacion)
        //Se trae valor en escala 1-5 (estrellas) y se multiplica el valor * 10 para llevarlo a escala 0 - 100.
        reputacionPromedio = (arrayReputacionPromedio[0] * 100) / ESTRELLAS_REPUTACION
      }
      return reputacionPromedio
    },
    [reputacion]
  )

  const abrirModal = useCallback(() => {
    setShow(true)
  }, [])

  const cerrarModal = useCallback(() => {
    setShow(false)
    //imagen();
    props.cambiarImagenPerfil()
  }, [props])

  const domicilio = domicilios.filter((d) => d.domicilioPrincipal === true)
  const direccionPrincipal = domicilio.map((d) => d.calle)
  const altura = domicilio.map((d) => d.calleAltura)

  return (
    <div className={styles.heroCard}>
      <div className={styles.heroIdentity}>
        <button
          onClick={abrirModal}
          className={styles.avatarButton}
          aria-label="Cambiar foto de perfil"
        >
          <div className={styles.avatarRing}>
            <ImagenPerfil idUsuario={idUsuario} clase="perfil-img-grande"></ImagenPerfil>
          </div>
        </button>
        <div>
          <h3 className={styles.heroName}>
            {datos.nombre} {datos.apellido}
          </h3>
          <p className={styles.heroHint}>Tocá tu foto para cambiarla</p>
        </div>
      </div>

      <div className={styles.heroStats}>
        <div className={styles.statBlock}>
          <div className={styles.statLabel}>Reputación vendedor</div>
          <div className={styles.reputacionRow}>
            <meter
              className="meter"
              min="0"
              max="100"
              low="30"
              high="70"
              optimum="100"
              value={obtenerReputacionPromedio(reputacion).toString()}
            ></meter>
            <span className={styles.reputacionValor}>
              {reputacion.length === 0 ? '0' : obtenerReputacionPromedio(reputacion)}%
            </span>
          </div>
        </div>

        <div className={styles.statBlock}>
          <div className={styles.statLabel}>Dirección principal</div>
          <div className={styles.statValue}>
            {direccionPrincipal.length ? (
              <>
                {direccionPrincipal} {altura}
              </>
            ) : (
              'Sin domicilio cargado'
            )}
          </div>
        </div>
      </div>

      <Modal
        dialogClassName={styles.avatarModal}
        show={show}
        size="sm"
        toggle={props.toggle}
        onHide={cerrarModal}
        centered
      >
        <Modal.Header closeButton onClick={cerrarModal}>
          <Modal.Title>Cambiá tu foto de perfil</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Upload accept={{ 'image/*': [] }} idTipo={idTipo} idUsuario={idUsuario} />
        </Modal.Body>
        <Modal.Footer>
          <button type="button" onClick={cerrarModal} className={styles.modalCancelButton}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default Hero

Hero.propTypes = {
  cambiarImagenPerfil: PropTypes.func.isRequired,
  toggle: PropTypes.func
}
